import React from "react";
export const HintField = ({ error, ...rest }) => {
  return (
    <div className="fv-plugins-message-container" {...rest}>
      <div className="fv-help-block" style={{ color: "red" }}>
        {error}
      </div>
    </div>
  );
};
